import { useState } from 'react';
import { SerializedError } from '@reduxjs/toolkit';
import { useForm, RegisterOptions } from 'react-hook-form';

import { useAppDispatch } from '../../app/hooks';
import { resetPasswordAction } from './authSlice';
import { ResetPasswordBody } from '../../handlers';
import { push, route_path } from '../../app/route';

const initialState: ResetPasswordBody = {
  password: '',
};

const field_options: Partial<Record<keyof ResetPasswordBody, RegisterOptions>> = {
  password: { 
    required: 'Password is required',
  },
};

export function SetPasswordCallback() {
  const dispatch = useAppDispatch();
  const { register, handleSubmit, watch, formState: { errors } } = useForm({
    defaultValues: initialState,
  });
  const [api_error, setApiError] = useState<SerializedError|undefined>();

  const onResetPassword = async(data: typeof initialState) => {
    let signup_result = await dispatch(resetPasswordAction(data));
    if (resetPasswordAction.rejected.match(signup_result)) {
      setApiError(signup_result.error);
      const subscription = watch(() => {
        setApiError(undefined);
        subscription.unsubscribe();
      });
    } else {
      dispatch(push(route_path.login));
    }
  };

  return (
    <div className="container-lg">
      <div className="row justify-content-md-center">
        <form className="col col-md-5 card border-dark mb-3 mt-5" onSubmit={handleSubmit(onResetPassword)}>
          <div className="card-body">
            <div className="mb-3">
              <label htmlFor="password" className="form-label">Email</label>
              <input
                type="password"
                className="form-control"
                id="password"
                placeholder="password"
                { ...register('password', field_options.password) }
              />
              <span className="text-danger">{errors.password?.message}</span>
            </div>
            <span className="text-danger">{api_error?.message ?? api_error?.name}</span>
            <div className="d-grid gap-2 mt-5">
              <button type="submit" className="btn btn-outline-primary">Set Password</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
